import { render, staticRenderFns } from "./addClasses.vue?vue&type=template&id=f15c111a&scoped=true&"
import script from "./addClasses.vue?vue&type=script&lang=js&"
export * from "./addClasses.vue?vue&type=script&lang=js&"
import style0 from "./addClasses.vue?vue&type=style&index=0&id=f15c111a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f15c111a",
  null
  
)

export default component.exports